import React, { useState } from "react";

import Servicesbanner from '../Servicesbanner';
import Servicescontent from '../Servicescontent';
import Testimonials from '../Testimonials';
import Servicesstep from '../Servicesstep';
import LCissuance from "../LCissuance";

const Applyforletterofcredit = () => {

  const [steps, setSteps] = useState([
    { 
      stepNumber: 1,
      stepbadgeText: "Step 1", 
      steptitle: "Request a Quote", 
      steptext: "Request a quote to receive today’s rate and expiration time. Once accepted, the order process begins. Rates depend on quantity, with larger orders typically receiving better rates, and all fees included.",
      stepimageSrc: "../Images/number-1.png"
    },
    { 
      stepNumber: 2,
      stepbadgeText: "Step 2", 
      steptitle: "Make Payment", 
      steptext: "Pay using the provided bank details and upload proof of payment along with the recipient's details. You’ll receive a confirmation notification once verified.<small style='color: var(--Red);display: block; margin-top: 10px;'>(Please note: No third-party payments are allowed, and ensure you complete the one-time KYC process before making any payments.)</small>",
      stepimageSrc: "../Images/number-2.png"
    },
    { 
      stepNumber: 3,
      stepbadgeText: "Step 3", 
      steptitle: "LC Processing", 
      steptext: "We begin processing your LC, which includes our banking partner issuing the LC based on the terms and conditions you’ve provided and transmitting it to the beneficiary’s bank. A copy of the LC will be forwarded to you.",
      stepimageSrc: "../Images/number-3.png"
    },
    { 
      stepNumber: 4,
      stepbadgeText: "Step 4", 
      steptitle: "LC Payment Released to Beneficiary", 
      steptext: "The payment is released to the supplier once all the terms of the LC have been fulfilled by the supplier.",
      stepimageSrc: "../Images/number-4.png"
    }
  ]);

  return (
    <>
      <Servicesbanner 
        title="Apply for" 
        highlight="Letter of Credit (LC)" 
        />
      <LCissuance />
      <Servicescontent 
        conttitle="Service Overview" 
        content={<><p>Our Letter of Credit (LC) service provides businesses with a reliable and secure method for international trade transactions, ensuring that both buyers and suppliers have financial assurance.</p><p>By offering a trusted payment guarantee, our LC service minimizes risks, improves cash flow management, and facilitates smoother cross-border transactions. We assist with LC issuance, amendments, and compliance, working closely with global financial partners to deliver tailored LC solutions.</p></>}
        buttonlink="#"
        label="Request an LC Quote"
      />
      <Servicesstep 
        steps={steps} 
      />
      <Testimonials />
    </>
  );
}

export default Applyforletterofcredit;
